var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'header-top': true, fixed: _vm.height > 10 ? true : false }})}
var staticRenderFns = []

export { render, staticRenderFns }